import { t } from "@/i18n-js/instance";
import { ConfirmationModal } from "@/react/components/SettingsApp/CompassCompat/ConfirmationModal";

interface SendMessageConfirmationModalProps {
  chatParticipantsCount: number;
  handleSubmit: (shouldSubmit: boolean) => void;
  shouldShowConfirmationModal: boolean;
  toggleConfirmationModal: () => void;
}

export const SendMessageConfirmationModal = ({
  shouldShowConfirmationModal,
  toggleConfirmationModal,
  handleSubmit,
  chatParticipantsCount,
}: SendMessageConfirmationModalProps) => (
  <ConfirmationModal
    isOpen={shouldShowConfirmationModal}
    onClose={toggleConfirmationModal}
    onConfirm={() => {
      handleSubmit(true);
      toggleConfirmationModal();
    }}
    confirmText={t("send")}
    title={t("messaging.send_group_message.title", {
      participants_count: chatParticipantsCount,
    })}
    modalBodyClassName="mb-6"
  >
    {t("messaging.send_group_message.description")}
  </ConfirmationModal>
);
